import coreApi from './coreApi'
import ies5Api from './ies5Api'
import sokplatformApi from './sokplatformApi'

export default {
    coreApi,
    ies5Api,
    sokplatformApi
}
